import { Box, Grid } from "@mui/material";
import Meta from "../../../../components/common/Meta";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import Generator from "./components/Generator";
import Library from "./components/Library";

const VoiceGenerator = () => {
  const { t } = useTranslation();
  // 生成完了を通知するためのstate
  const [generationCompleted, setGenerationCompleted] = useState(false);
  // ライブラリの開閉状態を管理するstate
  const [isLibraryExpanded, setIsLibraryExpanded] = useState(true);

  // 開閉状態をローカルストレージに保存する
  const handleExpandChange = (expanded: boolean) => {
    setIsLibraryExpanded(expanded);
  };

  return (
    <>
      <Meta title={t("voice.title")} meta={[{ name: "robots", content: "noindex, nofollow" }]} />
      <Box sx={{ mx: 2 }}>
        <Grid container spacing={2}>
          <Grid
            sx={{
              transition: "all 0.3s ease",
            }}
            size={{
              xs: 12,
              md: isLibraryExpanded ? 3 : 7,
            }}
          >
            <Generator generationCompleted={generationCompleted} setGenerationCompleted={setGenerationCompleted} />
          </Grid>
          <Grid
            sx={{
              transition: "all 0.3s ease",
            }}
            size={{
              xs: 12,
              md: isLibraryExpanded ? 9 : 5,
            }}
          >
            <Library
              generationCompleted={generationCompleted}
              isExpanded={isLibraryExpanded}
              onExpandChange={handleExpandChange}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default VoiceGenerator;
